// feature/auditoria-diaria — Auditoría diaria. Consolidated daily ops dashboard.
// Live data; future cron snapshot is deferred (see FOLLOWUPS.md).
import React, { useEffect, useState } from "react";
import { admin as adminApi } from "../../api/endpoints";
import Spinner from "../../components/Spinner";
import { TIPO_LABEL } from "../../components/Pills";

function todayBogota() {
  return new Date().toLocaleDateString("en-CA", { timeZone: "America/Bogota" });
}

export default function AuditoriaDiaria() {
  const [fecha, setFecha] = useState(todayBogota());
  const [data, setData] = useState(null);
  const [loadedAt, setLoadedAt] = useState(null);

  function load() {
    setData(null);
    adminApi.auditoriaDiaria(fecha)
      .then(r => { setData(r.data); setLoadedAt(new Date()); })
      .catch(() => setData({ error: true }));
  }
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [fecha]);

  return (
    <div className="col" style={{ gap: 16 }}>
      <div className="row" style={{ alignItems: "center" }}>
        <div>
          <h1 style={{ margin: 0 }}>Auditoría diaria</h1>
          <div className="muted" style={{ marginTop: 4 }}>Consolidación del día. Hora de Bogotá.</div>
        </div>
        <div style={{ flex: 1 }} />
        <input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} max={todayBogota()} />
        <button className="secondary" onClick={load}>Generar reporte</button>
        {loadedAt && (
          <span className="muted" style={{ fontSize: 12, marginLeft: 8 }}>
            Última actualización: {loadedAt.toLocaleTimeString("es-CO")}
          </span>
        )}
      </div>

      {data == null ? (
        <div className="card" style={{ padding: 32, textAlign: "center" }}><Spinner size={20} /></div>
      ) : data.error ? (
        <div className="card warn-inline">No se pudo cargar el reporte.</div>
      ) : (
        <>
          <div className="glass-section">
            <h3>Resumen del día</h3>
            <ul style={{ margin: 0, paddingLeft: 18, fontSize: 13 }}>
              <li>Casos respondidos: <strong>{data.resumen.respondidos}</strong></li>
              <li>Casos abiertos hoy: <strong>{data.resumen.abiertos}</strong></li>
              <li>Casos vencidos pendientes: <strong>{data.resumen.vencidos_pendientes}</strong></li>
            </ul>
          </div>

          <div className="glass-section">
            <h3>Insumos</h3>
            <ul style={{ margin: 0, paddingLeft: 18, fontSize: 13 }}>
              <li>Solicitados: <strong>{data.insumos.solicitados}</strong></li>
              <li>Recibidos: <strong>{data.insumos.recibidos}</strong></li>
              <li>Devueltos: <strong>{data.insumos.devueltos}</strong></li>
            </ul>
          </div>

          <div className="glass-section">
            <h3>Por tipo de actuación</h3>
            <table>
              <thead>
                <tr><th>Tipo</th><th>Abiertos hoy</th><th>Contestados hoy</th></tr>
              </thead>
              <tbody>
                {data.por_tipo.map(r => (
                  <tr key={r.tipo}>
                    <td>{TIPO_LABEL[r.tipo] || r.tipo}</td>
                    <td>{r.abiertos}</td>
                    <td>{r.contestados}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
